import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc, updateDoc, doc, getDocs } from 'firebase/firestore';
import { storage, db } from '../../../firebase';

const EditPlatModal = ({ selectedPlat, categoriesMap, onClose, onSubmit, show }) => {
    const [editedPlat, setEditedPlat] = useState({ ...selectedPlat });
    const [imageFile, setImageFile] = useState(null);
    const [imageUrl, setImageUrl] = useState(editedPlat.image || '');
    const [sizes, setSizes] = useState(selectedPlat.sizes || [{ nom: '', prix: '' }]); // For variable sizes

    const [selectedModules, setSelectedModules] = useState(editedPlat.addons || []); // Les modules déjà sélectionnés
    const [prixType, setPrixType] = useState(editedPlat.prixType || 'fixe'); // Default to 'fixe'
    const [addons, setAddons] = useState([]); // Modules complémentaires disponibles
    const [selectedAddon, setSelectedAddon] = useState('');

    useEffect(() => {
        const fetchAddons = async () => {
            try {
                const addonsCollection = collection(db, 'addons');
                const addonsSnapshot = await getDocs(addonsCollection);
                const addonsList = addonsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setAddons(addonsList);
            } catch (error) {
                console.error("Error fetching addons: ", error);
            }
        };
        fetchAddons();
    }, []);

    // Gestion du changement dans les champs d'input
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEditedPlat(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleImageChange = (e) => {
        if (e.target.files[0]) {
            setImageFile(e.target.files[0]);
        }
    };

    const handleSizeChange = (index, field, value) => {
        const newSizes = [...sizes];
        newSizes[index][field] = value;
        setSizes(newSizes);
    };

    const addSizeField = () => {
        setSizes([...sizes, { nom: '', prix: '' }]);
    };

    // Gestion des modules sélectionnés dans un addon
    const handleModuleSelection = (addonId, moduleName, isChecked, modulePrice) => {
        setSelectedModules(prevSelectedModules => {
            const addonIndex = prevSelectedModules.findIndex(addon => addon.id === addonId);
    
            if (isChecked) {
                // Si l'addon existe déjà, on ajoute le module
                if (addonIndex !== -1) {
                    const updatedModules = [...prevSelectedModules];
                    updatedModules[addonIndex] = {
                        ...updatedModules[addonIndex],
                        modules: [...updatedModules[addonIndex].modules, { nom: moduleName, prix: modulePrice }]
                    };
                    return updatedModules;
                } else {
                    // Si l'addon n'existe pas, on l'ajoute avec le module
                    return [
                        ...prevSelectedModules,
                        { id: addonId, nom: moduleName, modules: [{ nom: moduleName, prix: modulePrice }] }
                    ];
                }
            } else {
                // Si décoché, on supprime le module
                if (addonIndex !== -1) {
                    const updatedModules = [...prevSelectedModules];
                    updatedModules[addonIndex] = {
                        ...updatedModules[addonIndex],
                        modules: updatedModules[addonIndex].modules.filter(module => module.nom !== moduleName)
                    };
                    // Si aucun module n'est sélectionné, on supprime l'addon
                    if (updatedModules[addonIndex].modules.length === 0) {
                        updatedModules.splice(addonIndex, 1);
                    }
                    return updatedModules;
                }
            }
    
            return prevSelectedModules;
        });
    };
    

    // Ajouter un addon sélectionné
    const handleAddAddon = () => {
        if (selectedAddon && !selectedModules.find(addon => addon.id === selectedAddon)) {
            const addon = addons.find(a => a.id === selectedAddon);
            setSelectedModules([...selectedModules, { ...addon }]);
            setSelectedAddon('');
        } else {
            alert("Ce module est déjà sélectionné.");
        }
    };

    // Soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Vérifiez que prix n'est ni null ni undefined avant de le convertir en string
        let updatedPlat = {
            ...editedPlat,
            prix: editedPlat.prix !== null ? editedPlat.prix.toString() :null,
            sizes, // Save sizes
            prixType, // Save prixType
            addons: selectedModules // Inclure les addons et modules sélectionnés
        };
    
        // Vérifiez si un fichier image est présent et procédez au téléchargement
        if (imageFile) {
            const storage = getStorage();
            const storageRef = ref(storage, `images/${imageFile.name}`);
            await uploadBytes(storageRef, imageFile);
            const downloadURL = await getDownloadURL(storageRef);
            updatedPlat = { ...updatedPlat, image: downloadURL };
        }
    
     
     
    
        // Appeler la fonction onSubmit avec les données mises à jour
        onSubmit(updatedPlat);
    };
    

    useEffect(() => {
      
        setEditedPlat({ ...selectedPlat });
        setImageUrl(selectedPlat.image || '');
        setPrixType(selectedPlat.prixType || 'fixe');
    }, [selectedPlat]);

    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Modifier {selectedPlat.nom}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-4">
                                <Form.Group controlId="formPlatImage">
                                    <Form.Label>Image</Form.Label>
                                    <Form.Control
                                        type="file"
                                        onChange={handleImageChange}
                                    />
                                    {imageUrl && <img src={imageUrl} alt="Plat" style={{ width: '100%', marginTop: '10px' }} />}
                                </Form.Group>
                            </div>
                            <div className="col-md-8">
                                <Form.Group controlId="formPlatNom">
                                    <Form.Label>Nom</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nom"
                                        value={editedPlat.nom || ''}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formPlatCategorie">
                                    <Form.Label>Catégorie</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="categorie"
                                        value={editedPlat.categorie || ''}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        {Object.entries(categoriesMap).map(([key, value]) => (
                                            <option key={key} value={key}>{value}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>

                                <Form.Group controlId="formPlatDescription">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        name="description"
                                        value={editedPlat.description || ''}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formPrixType">
                                    <Form.Label>Type de prix</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={prixType}
                                        onChange={(e) => setPrixType(e.target.value)}
                                        required
                                    >
                                        <option value="fixe">Prix fixe</option>
                                        <option value="variable">Prix variable</option>
                                    </Form.Control>
                                </Form.Group>

                                {prixType === 'fixe' && (
                                    <Form.Group controlId="formPlatPrix">
                                        <Form.Label>Prix</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="prix"
                                            value={editedPlat.prix || ''}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                )}

                                {prixType === 'variable' && (
                                    <Form.Group controlId="formPlatTaille">
                                        <Form.Label>Prix par taille</Form.Label>
                                        {sizes.map((size, index) => (
                                            <div key={index} className="d-flex mb-2">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Nom de la taille"
                                                    value={size.taille}
                                                    onChange={(e) => handleSizeChange(index, 'taille', e.target.value)}
                                                />
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Prix"
                                                    value={size.prix}
                                                    onChange={(e) => handleSizeChange(index, 'prix', e.target.value)}
                                                />
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={addSizeField}>Ajouter une taille</Button>
                                    </Form.Group>
                                )}
                                {/* Ajouter un addon */}
                                <Form.Group controlId="formAddon">
                                    <Form.Label>Ajouter un module complémentaire</Form.Label>
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            as="select"
                                            value={selectedAddon}
                                            onChange={(e) => setSelectedAddon(e.target.value)}
                                            className="mr-3"
                                        >
                                            <option value="">Sélectionner un module</option>
                                            {addons.map(addon => (
                                                <option key={addon.id} value={addon.id}>
                                                    {addon.nom}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Button type="button" className="btn btn-primary mt-2" onClick={handleAddAddon}>
                                            Ajouter
                                        </Button>
                                    </div>
                                </Form.Group>

                                {/* Afficher les addons et leurs modules */}
                                {addons.map((addon) => (
                                    <div key={addon.id}>
                                        <strong>{addon.nom}</strong>
                                        {addon.modules.map((module) => (
                                            <Form.Check
                                                key={module.nom}
                                                type="checkbox"
                                                label={`${module.nom} (${module.prix}€)`}
                                                // Vérifier si l'addon et le module sont déjà dans `selectedModules`
                                                checked={selectedModules.some(selectedAddon =>
                                                    selectedAddon?.id === addon.id &&
                                                    Array.isArray(selectedAddon.modules) &&
                                                    selectedAddon.modules.some(selectedModule => selectedModule.nom === module.nom)
                                                )}
                                                
                                                onChange={(e) => handleModuleSelection(addon.id, module.nom, e.target.checked, module.prix)}
                                            />
                                        ))}
                                    </div>
                                ))}

 
                                <Form.Group controlId="formPlatDisponible">
                                    <Form.Check
                                        type="checkbox"
                                        label="Disponible"
                                        name="disponible"
                                        checked={editedPlat.disponible || false}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                                {/* Checkbox pour Végétarienne */}
                                <Form.Group controlId="formPlatVegetarian">
                                    <Form.Check
                                        type="checkbox"
                                        label="Vegetarienne"
                                        name="vegetarienne"
                                        checked={editedPlat.vegetarienne || false}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>

                                <Button variant="primary" type="submit">
                                    Enregistrer les modifications
                                </Button>
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditPlatModal;
